import { render, staticRenderFns } from "./VideoLightBox.vue?vue&type=template&id=0b500910&"
import script from "./VideoLightBox.vue?vue&type=script&lang=js&"
export * from "./VideoLightBox.vue?vue&type=script&lang=js&"
import style0 from "./VideoLightBox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports